import * as z from "zod/v4";

export const claimWorkOrderStep = {
  name: "claimWorkOrderStep" as const,
  input: z.object({
    workOrderId: z.string(),
    force: z.boolean().default(false),
  }),
  output: z.object({
    claimed: z.boolean(),
    conflict: z
      .object({
        currentUserName: z.string(),
        currentUserId: z.string(),
        bulkPickSessionId: z.string().nullable(),
      })
      .nullable(),
  }),
};
